import { FilterVal } from 'src/interfaces/iproptypes';

export const transformFilterVals = (filterVals: FilterVal) => {
  const validateArrayTypeFilters = (filter, allowedValues, convertToString = false) => {
    if (!filter) return null;

    const filterToUse = convertToString
      ? filter.map(String).filter(value => allowedValues.includes(value))
      : filter.filter(value => allowedValues.includes(value));

    return filterToUse.length > 0 ? filterToUse : null;
  };

  const validateMinMaxFilters = (filter, minAllowedValue, maxAllowedValue) => {
    if (!filter) {
      return [null, null];
    }

    if (filter[0] == minAllowedValue && filter[1] == maxAllowedValue) {
      return [null, null];
    }

    return filter;
  };

  const validateSingleValueFilter = (filter, allowedValues, isNumber) => {
    filter = isNumber ? Number(filter) : filter;

    if (filter == null || !allowedValues.includes(filter)) {
      return null;
    }
    return filter;
  };

  return {
    bedrooms: validateArrayTypeFilters(
      filterVals.bedrooms,
      ['0', '1', '2', '3', '4', '5', '6', 'private_room', 'shared_room', 'hotel_room'],
      true
    ),
    property_type: validateArrayTypeFilters(filterVals.roomType, ['entire_home', 'condo']),
    bathrooms: validateArrayTypeFilters(filterVals.bathrooms, [1, 2, 3, 4, 5, 6]),
    accommodates_min: validateMinMaxFilters(filterVals.accommodates, 1, 16)[0],
    accommodates_max: validateMinMaxFilters(filterVals.accommodates, 1, 16)[1],
    min_nights_min: validateMinMaxFilters(filterVals.minimum_nights, 1, 30)[0],
    min_nights_max: validateMinMaxFilters(filterVals.minimum_nights, 1, 30)[1],
    professionally_managed:
      filterVals.hostType === 'both' ? null : filterVals.hostType === 'professional' ? 1 : 0,
    rating_min: validateMinMaxFilters(filterVals.rating, 3.9, 5)[0],
    rating_max: validateMinMaxFilters(filterVals.rating, 3.9, 5)[1],
    review_count_min: validateSingleValueFilter(filterVals.number_of_reviews, [1, 3, 10, 30], true),
    amenities: filterVals.amenities,
    // price_tier:
    //   filterVals.priceTierFilter && filterVals.priceTierFilter[0] !== 'all'
    //     ? filterVals.priceTierFilter[0]
    //     : null,
    // revenue_filter:
    //   filterVals.revenueFilter && filterVals.revenueFilter[0] !== 'all'
    //     ? filterVals.revenueFilter[0]
    //     : null,
  };
};
